const LOOKBOOK_MOBILE_BREAKPOINT = 989;

let lookbookMobileSheet = null;
let lookbookBackdrop = null;
let lookbookSwiper = null;

function isLookbookMobile() {
  return window.innerWidth <= LOOKBOOK_MOBILE_BREAKPOINT;
}

function initLookbookTags() {
  const sections = document.querySelectorAll('.lookbook-image-block');

  sections.forEach(section => {
    const tags = section.querySelectorAll('.lookbook-product-tag');
    initLookbookScrollAnimation(section, tags);
    initLookbookPanelPositioning(tags);
    initLookbookMobileInteractions(tags);
  });

  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      const allTags = document.querySelectorAll('.lookbook-product-tag');
      initLookbookPanelPositioning(allTags);
    }, 250);
  });
}

function initLookbookScrollAnimation(section, tags) {
  let scrollTimeout;
  let isScrolling = false;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        window.addEventListener('scroll', handleScroll, { passive: true });
      } else {
        window.removeEventListener('scroll', handleScroll);
        tags.forEach(tag => tag.classList.remove('lookbook-product-tag--animate'));
      }
    });
  }, { threshold: 0.2 });

  observer.observe(section);

  function handleScroll() {
    if (!isScrolling) {
      isScrolling = true;
      tags.forEach(tag => tag.classList.add('lookbook-product-tag--animate'));
    }

    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      isScrolling = false;
      tags.forEach(tag => tag.classList.remove('lookbook-product-tag--animate'));
    }, 1500);
  }
}

function initLookbookPanelPositioning(tags) {
  if (isLookbookMobile()) return;

  tags.forEach(tag => {
    const panel = tag.querySelector('.lookbook-product-tag__panel');
    if (!panel) return;

    const panelPosition = tag.dataset.panelPosition || 'auto';

    if (panelPosition === 'auto') {
      const tagRect = tag.getBoundingClientRect();
      const panelWidth = 280;
      const viewportWidth = window.innerWidth;

      if (tagRect.right + panelWidth + 24 > viewportWidth) {
        panel.classList.add('lookbook-product-tag__panel--left');
      } else {
        panel.classList.remove('lookbook-product-tag__panel--left');
      }
    } else if (panelPosition === 'left') {
      panel.classList.add('lookbook-product-tag__panel--left');
    } else {
      panel.classList.remove('lookbook-product-tag__panel--left');
    }
  });
}

function initLookbookMobileInteractions(tags) {
  tags.forEach(tag => {
    const button = tag.querySelector('.lookbook-product-tag__button');
    if (!button) return;

    button.addEventListener('click', function(e) {
      if (!isLookbookMobile()) return;

      e.preventDefault();
      e.stopPropagation();

      const productData = {
        handle: tag.dataset.productHandle,
        title: tag.dataset.productTitle,
        price: tag.dataset.productPrice,
        url: tag.dataset.productUrl,
        images: JSON.parse(tag.dataset.productImages || '[]')
      };

      openLookbookMobileSheet(productData);
    });
  });
}

function createLookbookMobileSheet() {
  if (document.querySelector('.lookbook-mobile-sheet')) return;

  lookbookBackdrop = document.createElement('div');
  lookbookBackdrop.className = 'lookbook-mobile-sheet__backdrop';
  lookbookBackdrop.addEventListener('click', closeLookbookMobileSheet);

  lookbookMobileSheet = document.createElement('div');
  lookbookMobileSheet.className = 'lookbook-mobile-sheet';
  lookbookMobileSheet.innerHTML = `
    <div class="lookbook-mobile-sheet__handle"></div>
    <button class="lookbook-mobile-sheet__close" type="button" aria-label="Close">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
    <div class="lookbook-mobile-sheet__content">
      <div class="lookbook-mobile-sheet__swiper swiper">
        <div class="swiper-wrapper"></div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="lookbook-mobile-sheet__product-info">
        <h3 class="lookbook-mobile-sheet__title"></h3>
        <div class="lookbook-mobile-sheet__price-row">
          <p class="lookbook-mobile-sheet__price"></p>
          <a href="#" class="lookbook-mobile-sheet__link">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.125 3.27539C10.3007 3.27539 10.4695 3.34455 10.5938 3.46875L15.6562 8.53125C15.7178 8.59278 15.7665 8.66664 15.7998 8.74707C15.833 8.8273 15.8505 8.91317 15.8506 9C15.8506 9.08705 15.8331 9.17349 15.7998 9.25391C15.7665 9.33425 15.7178 9.40726 15.6562 9.46875L10.5938 14.5312C10.4694 14.6556 10.3008 14.7256 10.125 14.7256C9.94921 14.7256 9.78055 14.6556 9.65625 14.5312C9.53205 14.407 9.46191 14.2382 9.46191 14.0625C9.462 13.8868 9.53202 13.718 9.65625 13.5938L13.5879 9.66309H2.8125C2.63679 9.66309 2.46799 9.59299 2.34375 9.46875C2.21961 9.34452 2.15039 9.17563 2.15039 9C2.15047 8.82456 2.21979 8.65636 2.34375 8.53223C2.46799 8.40798 2.63679 8.33789 2.8125 8.33789H13.5879L9.65625 4.40625C9.53205 4.28196 9.46191 4.11322 9.46191 3.9375C9.462 3.76182 9.53202 3.59298 9.65625 3.46875C9.78054 3.34455 9.94929 3.27539 10.125 3.27539Z" fill="currentColor"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  `;

  lookbookMobileSheet.querySelector('.lookbook-mobile-sheet__close').addEventListener('click', closeLookbookMobileSheet);

  document.body.appendChild(lookbookBackdrop);
  document.body.appendChild(lookbookMobileSheet);

  initLookbookTouchGestures();
}

function initLookbookTouchGestures() {
  if (!lookbookMobileSheet) return;

  let startY = 0;
  let currentY = 0;
  let isDragging = false;

  lookbookMobileSheet.addEventListener('touchstart', function(e) {
    const touch = e.touches[0];
    const sheetRect = lookbookMobileSheet.getBoundingClientRect();
    if (touch.clientY - sheetRect.top < 60) {
      startY = touch.clientY;
      isDragging = true;
    }
  }, { passive: true });

  lookbookMobileSheet.addEventListener('touchmove', function(e) {
    if (!isDragging) return;
    currentY = e.touches[0].clientY;
    const diff = currentY - startY;

    if (diff > 0) {
      lookbookMobileSheet.style.transform = `translateY(${diff}px)`;
    }
  }, { passive: true });

  lookbookMobileSheet.addEventListener('touchend', function() {
    if (!isDragging) return;

    const diff = currentY - startY;

    if (diff > 100) {
      closeLookbookMobileSheet();
    } else {
      lookbookMobileSheet.style.transform = '';
    }

    startY = 0;
    currentY = 0;
    isDragging = false;
  });
}

function openLookbookMobileSheet(productData) {
  createLookbookMobileSheet();

  if (!lookbookMobileSheet) return;

  lookbookMobileSheet.querySelector('.lookbook-mobile-sheet__title').textContent = productData.title;
  lookbookMobileSheet.querySelector('.lookbook-mobile-sheet__price').textContent = productData.price;
  lookbookMobileSheet.querySelector('.lookbook-mobile-sheet__link').href = productData.url;

  const swiperWrapper = lookbookMobileSheet.querySelector('.swiper-wrapper');

  if (productData.images && productData.images.length > 0) {
    swiperWrapper.innerHTML = productData.images.map(function(img) {
      let imgSrc = img;
      if (img.includes('?')) {
        imgSrc = img.split('?')[0] + '?width=800';
      } else if (!img.includes('width=')) {
        imgSrc = img + '?width=800';
      }
      return `
        <div class="swiper-slide">
          <img src="${imgSrc}" alt="${productData.title}" loading="lazy">
        </div>
      `;
    }).join('');
  } else {
    swiperWrapper.innerHTML = `
      <div class="swiper-slide">
        <div style="width:100%;aspect-ratio:1/1;background:#f5f6f7;display:flex;align-items:center;justify-content:center;">
          <span style="color:#999;">No image</span>
        </div>
      </div>
    `;
  }

  if (lookbookSwiper) {
    lookbookSwiper.destroy(true, true);
  }

  setTimeout(function() {
    lookbookSwiper = new Swiper(lookbookMobileSheet.querySelector('.lookbook-mobile-sheet__swiper'), {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: '.lookbook-mobile-sheet__swiper .swiper-pagination',
        clickable: true
      }
    });
  }, 10);

  lookbookBackdrop.classList.add('lookbook-mobile-sheet__backdrop--visible');
  lookbookMobileSheet.classList.add('lookbook-mobile-sheet--open');
  document.body.style.overflow = 'hidden';
}

function closeLookbookMobileSheet() {
  if (!lookbookMobileSheet) return;

  lookbookBackdrop.classList.remove('lookbook-mobile-sheet__backdrop--visible');
  lookbookMobileSheet.classList.remove('lookbook-mobile-sheet--open');
  lookbookMobileSheet.style.transform = '';
  document.body.style.overflow = '';

  setTimeout(function() {
    if (lookbookSwiper) {
      lookbookSwiper.destroy(true, true);
      lookbookSwiper = null;
    }
  }, 300);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLookbookTags);
} else {
  initLookbookTags();
}

document.addEventListener('shopify:section:load', function(event) {
  if (event.target.classList.contains('section-lookbook-image-block')) {
    initLookbookTags();
  }
});
